

import axios from 'axios';

import { Toast } from 'vant';

import router from '../router/index';


function getQueryString(name){
  var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if(r!=null)return  unescape(r[2]); return null;
}


const IMGURL='http://101.200.130.77:5002';
const BASEURL='http://101.200.130.77:9002';


let http = axios.create({
  baseURL: BASEURL,
  dataType: 'json',
  headers: {
    "Content-Type": "application/json;charset=utf-8",
  },
  transformResponse: [function (data) {
    return JSON.parse(data);
  }],
});


let http2 = axios.create({
  baseURL: BASEURL,
  dataType: 'json',
  headers: {
    "Content-Type": "application/json;charset=utf-8",
  },
  transformResponse: [function (data) {
    return JSON.parse(data);
  }],
});




function apiAxios(method, url, params) {
  return new Promise((resolve, reject) => {
   let toast= Toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: 0,
    });

    let headerData= sessionStorage.getItem('user')||'';
    let header;
    if(headerData){
      header={"userToken":JSON.parse(sessionStorage.getItem('user')).token};
    }


    http({
      method: method,
      url: url,
      headers:header,
      data: method === 'POST' || method === 'PUT' ? params : null,
      params: method === 'GET' || method === 'DELETE' ? params : null,
    }).then(function (res) {
      toast.clear();
      if(res.data.retCode==0){
        resolve(res.data);
      }else{
        if(res.data.retCode=="80200" || res.data.retCode=="80205"){
          localStorage.setItem('autoLogin', false);
          router.replace({name:'Login'});
        }else{
          Toast(res.data.message);
          reject(res.data);
        }
      }
     
    }).catch(function (err) {
      console.log(err);
      toast.clear();
      Toast('系统错误');
      reject(err);
    });

  });

}



export default {
  get: function (url, params,) {
    return apiAxios('GET', url, params)
  },
  post: function (url, params,) {
    return apiAxios('POST', url, params)
  },
  put: function (url, params,) {
    return apiAxios('PUT', url, params)
  },
  delete: function (url, params,) {
    return apiAxios('DELETE', url, params)
  },
  baseUrl(){
    return BASEURL;
  },
  IMGURL(){
    return IMGURL;
  }
}